import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import ClearAll_001 from './img/ClearAll_001.jpg'
import ClearAll_002 from './img/ClearAll_002.jpg'
import ClearAll_003 from './img/ClearAll_003.jpg'

export default class ClearAll extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">使用清除功能</div>
        <div className="main-window-content">点击清除，直接清除球上所有勾选测量操作</div>
        <img src={ClearAll_001} className="main-window-img"></img>
        <img src={ClearAll_002} className="main-window-img"></img>
        <img src={ClearAll_003} className="main-window-img"></img>
      </div>
    )
  }
}
